import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatStepper } from '@angular/material/stepper';
import { HelperService } from 'projects/fe-career/src/app/service/helper.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { DomSanitizer } from '@angular/platform-browser';
import { ExecuteOrderStatus } from '../manage-order.model';



interface OrderItemNode {
  status: any;
  customize: boolean;
 
  etcNew: any;
  quantity: number;
  selectEnabled: boolean;
 
  expandable: boolean;
  etcData: any;
  hasChild: number;
  id: string;
  customizeVisible: boolean;
  sellingCatalogTypeId: any;
  sellingCatalogType: any;
  expectedTimeToDeliver: any;
  level: any;
  macroTaskName: any;
  taskName: any;
  unitName: any;
  name: string;
  qty?: number;
  etc?: string;
  children?: OrderItemNode[];
  editable?: boolean;
  fixedVariablePrice?: number;
  sellingCatalogId?: string;
  sellingCatalogName?: string;
  _id: string;
  uniqueId: number;


}

interface FlatNode {
  expandable: boolean;
  name: string;
  level: number;
  qty?: number;
  etc?: string;
  editable?: boolean;
  sellingCatalogId?: string;
  sellingCatalogName?: string;
  etcData?: any;
  customize: boolean;
  sellingCatalogTypeId: string;
  sellingCatalogType: string;
  id: string;
  uniqueId: number;
  customizeVisible: boolean;
}
@Component({
  selector: 'app-order-task-detail',
  templateUrl: './order-task-detail.component.html',
  styleUrls: ['./order-task-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderTaskDetailComponent implements OnInit {


  totalCostPrice: number = 0;
  etc: string = "";
  selectedCatalog;
  catalogs = [];

  selection = new SelectionModel<any>(true, []);
  title = 'ORDERMANAGEMENT.ViewLabel';
  displayedColumns: string[] = ['name', 'qty', 'etc',  'status'];

  @ViewChild('stepper') stepper!: MatStepper;

  treeControl = new FlatTreeControl<FlatNode>(
    node => node.level,
    node => node.expandable
  );
  @Input() orderId = "";
  disabledMode = false;
  originalCustomize = false;
  treeFlattener = new MatTreeFlattener(
    (node: OrderItemNode, level: number) => {
      if (this.originalCustomize) {
        return node;
      }
      node.status = node.status;
      node.expandable = !!node.children && node.children.length > 0;
      node.name = node.macroTaskName || node.taskName || node.unitName;
      node.level = level;
      node.qty = node.qty || 1;
      node.etc = node.expectedTimeToDeliver.time + ' ' + this.toTitleCase(node.expectedTimeToDeliver.type);
      node.editable = !node.level;
      node.sellingCatalogTypeId = node.sellingCatalogTypeId;
      node.sellingCatalogType = node.sellingCatalogType;
      node.etcData = node.expectedTimeToDeliver;
      node.customize = (this.orderDetails?.items?.length) ? (node.customize ? true : false) : (!level ? false : true);
      node.hasChild = node.children?.length;
      node.id = node._id;
      node.uniqueId = node.uniqueId;
      node.customizeVisible = node.hasChild && node.level === 0 ? true : false;
      node.selectEnabled = node.level === 0 ? true : false;
      return node;
    },
    node => node.level,
    node => node.expandable,
    node => node.children
  );
  private _orderDetails: any;

  @Input()
  set orderDetails(value: any) {
    this._orderDetails = value;
    if (value) {
      this.processOrderDetails();
 
    }
  }

  get orderDetails(): any {
    return this._orderDetails;
  }
  dataSource: any = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
  selectedItems = []
  orderItems: OrderItemNode[] = [];
  search = "";
  // Without Search
  originalNodes = [];
  manageCustomerRolePermission: any;

  executeOrderStatus = ExecuteOrderStatus
  supplierIcon = this.sanitizer.bypassSecurityTrustHtml('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M64 64a64 64 0 1 1 128 0A64 64 0 1 1 64 64zM25.9 233.4C29.3 191.9 64 160 105.6 160l44.8 0c27 0 51 13.4 65.5 34.1c-2.7 1.9-5.2 4-7.5 6.3l-64 64c-21.9 21.9-21.9 57.3 0 79.2L192 391.2l0 72.8c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-115.7c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM448 64a64 64 0 1 1 128 0A64 64 0 1 1 448 64zM431.6 200.4c-2.3-2.3-4.9-4.4-7.5-6.3c14.5-20.7 38.6-34.1 65.5-34.1l44.8 0c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6L576 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-72.8 47.6-47.6c21.9-21.9 21.9-57.3 0-79.2l-64-64zM272 240l0 32 96 0 0-32c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l64 64c9.4 9.4 9.4 24.6 0 33.9l-64 64c-6.9 6.9-17.2 8.9-26.2 5.2s-14.8-12.5-14.8-22.2l0-32-96 0 0 32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2z"/></svg>')
  peopleIcon = this.sanitizer.bypassSecurityTrustHtml('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z"/></svg>');
  constultantIcon = this.sanitizer.bypassSecurityTrustHtml('<svg fill="#fff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve"> <g> <g> <path d="M102.4,0C60.049,0,25.6,34.449,25.6,76.8c0,42.351,34.449,76.8,76.8,76.8c42.351,0,76.8-34.449,76.8-76.8 C179.2,34.449,144.751,0,102.4,0z M102.4,128c-28.279,0-51.2-22.921-51.2-51.2s22.921-51.2,51.2-51.2s51.2,22.921,51.2,51.2 S130.68,128,102.4,128z"/> </g> </g> <g> <g> <path d="M102.4,384h-64c-7.049,0-12.8-5.751-12.8-12.8V256c0-7.074-5.726-12.8-12.8-12.8C5.726,243.2,0,248.926,0,256v115.2 c0,21.171,17.229,38.4,38.4,38.4h12.8v76.8H38.4c-7.074,0-12.8,5.726-12.8,12.8c0,7.074,5.726,12.8,12.8,12.8h51.2 c7.074,0,12.8-5.726,12.8-12.8c0-7.074-5.726-12.8-12.8-12.8H76.8v-76.8h25.6c10.3,0,12.646,7.023,12.8,12.928 c0.077,6.997,5.777,12.672,12.8,12.672c7.074,0,12.8-5.726,12.8-12.8C140.8,406.972,130.577,384,102.4,384z"/> </g> </g> <g> <g> <path d="M409.6,0c-42.351,0-76.8,34.449-76.8,76.8c0,42.351,34.449,76.8,76.8,76.8s76.8-34.449,76.8-76.8 C486.4,34.449,451.951,0,409.6,0z M409.6,128c-28.279,0-51.2-22.921-51.2-51.2s22.921-51.2,51.2-51.2 c28.279,0,51.2,22.921,51.2,51.2S437.879,128,409.6,128z"/> </g> </g> <g> <g> <path d="M499.2,243.2c-7.074,0-12.8,5.726-12.8,12.8v115.2c0,7.049-5.751,12.8-12.8,12.8h-64c-28.177,0-38.4,22.972-38.4,38.4 c0,7.074,5.726,12.8,12.8,12.8c7.023,0,12.723-5.675,12.8-12.672c0.154-5.905,2.5-12.928,12.8-12.928h25.6v76.8h-12.8 c-7.074,0-12.8,5.726-12.8,12.8c0,7.074,5.726,12.8,12.8,12.8h51.2c7.074,0,12.8-5.726,12.8-12.8c0-7.074-5.726-12.8-12.8-12.8 h-12.8v-76.8h12.8c21.171,0,38.4-17.229,38.4-38.4V256C512,248.926,506.274,243.2,499.2,243.2z"/> </g> </g> <g> <g> <path d="M409.6,179.2c-28.228,0-51.2,22.972-51.2,51.2v58.351l-38.4,12.8V281.6h12.8c7.074,0,12.8-5.726,12.8-12.8 c0-7.074-5.726-12.8-12.8-12.8H179.2c-7.074,0-12.8,5.726-12.8,12.8c0,7.074,5.726,12.8,12.8,12.8H192v19.951l-38.4-12.8V230.4 c0-28.228-22.972-51.2-51.2-51.2s-51.2,22.972-51.2,51.2v102.4c0,11.75,7.996,21.99,19.388,24.832l86.682,21.675l22.426,112.119 C182.093,503.39,192.597,512,204.8,512h102.4c12.203,0,22.707-8.61,25.105-20.574l22.426-112.119l86.682-21.675 C452.804,354.79,460.8,344.55,460.8,332.8V230.4C460.8,202.172,437.828,179.2,409.6,179.2z M192,422.4l-12.8-64L76.8,332.8V230.4 c0-14.14,11.46-25.6,25.6-25.6c14.14,0,25.6,11.46,25.6,25.6v76.8l64,21.333V422.4z M294.4,310.835V409.6v76.8h-76.8v-76.8 v-98.765V281.6h76.8V310.835z M435.2,332.8l-102.4,25.6l-12.8,64-93.867l64-21.333v-76.8c0-14.14,11.46-25.6,25.6-25.6 c14.14,0,25.6,11.46,25.6,25.6V332.8z"/> </g> </g> </svg>')
  @Output() refreshEvent = new EventEmitter<void>();


  private isInsidePicker(target: HTMLElement, pickerId: string): boolean {
    const picker = document.querySelector(pickerId);
    return picker ? picker.contains(target) : false;
  }

  constructor(private cdRef: ChangeDetectorRef,
    private router: Router,
    private helper: HelperService,
    public translate: TranslateService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer


  ) {
    this.dataSource.data = this.orderItems;
  }

  hasChild = (_: number, node: FlatNode) => node.expandable;

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.orderId = id;

  }



  resetSearch(): void {
    this.search = '';
    this.dataSource.data = this.originalNodes;
  }
  findTopParentByName(nodes: any[], searchText: string): any[] {
    const result = new Set<any>();

    // Iterate through the top-level nodes
    for (const parent of nodes) {
      if (parent.name.toUpperCase().includes(searchText.toUpperCase())) {
        result.add(parent);
      }
      // Check children of each parent
      for (const child of parent.children || []) {
        if (child.name.toUpperCase().includes(searchText.toUpperCase())) {
          result.add(parent);
          const flatNode = this.treeControl.dataNodes.find(node => node.uniqueId === parent.uniqueId);
          if (flatNode) {
            this.treeControl.expand(flatNode)
          }
        }
        // Check grandchildren of each child
        for (const grandchild of child.children || []) {
          if (grandchild.name.toUpperCase().includes(searchText.toUpperCase())) {
            result.add(parent);
            const flatNode = this.treeControl.dataNodes.find(node => node.uniqueId === parent.uniqueId);
            if (flatNode) {
              this.treeControl.expand(flatNode)
            }
          }
        }
      }
    }

    return Array.from(result);
  }



  onKeyUp(searchTextValue: any): void {
    this.originalCustomize = true;
    if (this.search) {
      this.dataSource.data = this.findTopParentByName(this.originalNodes, this.search)
    } else {
      this.dataSource.data = this.originalNodes;
    }
    setTimeout(() => {
      this.originalCustomize = false;
    }, 1000);
  }

  // Method to reverse the changes from payload to tree nodes
  // reversePayloadToTree(payload: any): OrderItemNode[] {
  //   return payload.items.map(item => this.traverseItem(item));
  // }

  reversePayloadToTree(payload: any): OrderItemNode[] {
    return (payload?.items || [])
      .filter(item => !item.doNotInvoice || item.showInProposal)
      .map(item => this.traverseItem(item));
  }

  // Helper method to traverse each item recursively
  traverseItem(item: any) {
    const node = {
      _id: item._id,
      sellingCatalogTypeId: item.typeId,
      macroTaskName: item.name,
      taskName: item.name,
      unitName: item.name,
      status: item.status,
      taskId: item.taskId,
      expectedTimeToDeliver: item.expectedTimeToComplete,
      qty: item.quantity || 1,
      customize: item.customise || false,
      sellingCatalogType: item.type || '',
      children: (item.children || []).filter(child => !child.doNotInvoice || child.showInProposal).map(child => this.traverseItem(child)),

    };
    return node;
  }


  processOrderDetails() {

    if (this.orderDetails?.sellingCatalogId) {
      this.selectedCatalog = this.orderDetails.sellingCatalogId;
    }

    if (this.orderDetails?.items?.length) {
      this.totalCostPrice = this.orderDetails.totalCostPrice;

      this.etc = this.orderDetails.expectedTimeToComplete;
      this.helper.toggleLoaderVisibility(true);
      this.dataSource.data = this.reversePayloadToTree(this.orderDetails);
      this.traverseAndCalculateEstimatedTime(this.dataSource.data)
      this.traverseAndAddIds(this.dataSource.data)
      this.cdRef.detectChanges();
      setTimeout(() => {
        this.traverseAndCustomise(this.dataSource.data)
        this.originalNodes = [...this.dataSource.data];
  
      }, 100);

    }

  }




  transformCatalogData = (catalog) => {
    if (catalog.data && catalog.data.catalogList) {
      catalog.data.catalogList.forEach(item => {
        if (item.sellingCatalogDetails) {
          Object.assign(item, item.sellingCatalogDetails);
          delete item.sellingCatalogDetails;
        }
      });
    }
    return catalog;
  }

  uniqueIdCounter = 1;
  // Recursive function to traverse and modify children
  traverseAndAddIds = (items) => {
    items.forEach(item => {
      // Add unique ID to the current item
      this.uniqueIdCounter = this.uniqueIdCounter + 1
      item.uniqueId = this.uniqueIdCounter
      // Recursively traverse children if present
      if (item.children && Array.isArray(item.children)) {
        this.traverseAndAddIds(item.children);
      }
    });
  }

  traverseAndCustomise = (items) => {
    items.forEach(item => {

      item.selectEnabled = !item.customize;
      if (item.children && Array.isArray(item.children)) {
        item.customizeVisible = true;
        item.children.forEach(child => {
          child.selectEnabled = item.customize;
          if (child?.children?.length) {
            child.selectEnabled = !child.customize && item.customize;
            child.customizeVisible = item.customize;
            if (child.customize && item.customize) {
              child.children.forEach(grandChild => {
                grandChild.selectEnabled = true;
              })
            }

          }
        });

      }

    });
  }

  traverseAndCalculate = (items) => {
    for (const item of items) {
      if (item?.children?.length) {
        if (item?.customize) {
          item.costPrice = this.traverseAndCalculate(item.children);
          item.totalCostPrice = item.costPrice * item.qty;
        }
      }
    }

    return items.reduce((sum, item) => {
      return sum + item.costPrice
    }, 0);
  }

  traverseAndCalculateEstimatedTime = (items) => {
    for (const item of items) {
      if (item?.children?.length) {
        if (item.customize) {
          // Recursively calculate the estimated time for child items
          this.traverseAndCalculateEstimatedTime(item.children);

          // Initialize parent etcNewData
          item.etcNewData = { type: "DAYS", time: 0 };

          // Sum the etcData of children
          for (const child of item.children) {
            if (child.etcData) {
              const timeInDays = child.etcData.type === "HOUR" ? child.etcData.time / 8 : child.etcData.time;
              item.etcNewData.time = Number(item.etcNewData.time) + Number(timeInDays);
            }
          }

          // Format etcNew for the parent item
          item.etcNew = item.etcNewData.time + ' ' + this.toTitleCase(item.etcNewData.type);
        }
      }
    }
  }








  toTwoDecimal = (number) => {
    return parseFloat(number.toFixed(2));
  }
  toTitleCase = (str) => {
    if (str === 'HOUR') {
      str = 'HOURS'
    }
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  }







}
